import styled from 'styled-components';

export const Container = styled.div<{ $containerHasTopPadding: boolean }>`
  ${({ $containerHasTopPadding }) => $containerHasTopPadding && `padding-top: 20px;`}
  & div[class*='LoadingContainer'] {
    height: fit-content;
    width: unset;
  }
`;

export const StyledRecentItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: minmax(160px, 100%);
  width: 261px;
  margin: 0 auto;
  padding: 16px;
  box-shadow: ${Styles.boxShadow};
  background: ${Styles.color.cardBackground};
  border-radius: ${Styles.borderRadius};
  overflow: hidden;
`;

export const StyledRecentItemProduct = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const StyledRecentItemButton = styled.div`
  margin: 16px auto 8px auto;
`;
